<template>
  <!--
    This was added as part of GROW-821, but the AC did not call for an upgrade dialog to be displayed.
    Leaving this in, because I'm sure that will be a requirement at some point in the future.

    This design is not adequate; needs to be modified and made into a less-general dialog, specifically
    for the template feature.

    See discussion on slack here: https://cloudapp.slack.com/archives/CMJQB4W8Z/p1618415429069500
    -->
  <modal ref="upgradeModal" id="b-upgrade-modal" centered hide-footer hide-header content-class="upgradeModalRectangle">
    <template #modal-header="">&nbsp;</template>
    <template #default>
      <span class="Masthead">Upgrade your plan</span>
      <div class="logo">
        <b-img-lazy src="@img/zight-logomark-600-600.svg" center alt="Zight"></b-img-lazy>
      </div>

      <div class="description">
        <p>
          Upgrade to a Zight Pro plan today to unlock:
        </p>
        <ul>
          <li>Unlimited video recording</li>
          <li>Enhanced editing features</li>
          <li>Web-based annotations</li>
          <li>Custom buttons and settings</li>
          <li>Your own domain and branding</li>
          <li>Searching your items</li>
          <li>Advanced security settings</li>
          <li> ... and more</li>
        </ul>
      </div>
      <div class="button">
        <a href="/plans?utm_source=viewer&amp;utm_campaign=upgrade-modal"><button center class="cloudapp-btn blue">Upgrade Now</button></a><br>
        <button center class="cloudapp-btn" @click="$bvModal.hide('b-upgrade-modal');">Maybe later</button>
      </div>
    </template>
    <template #modal-footer="">&nbsp;</template>
  </modal>
</template>

<script>
import Modal from '@/src/components/modal';

export default {
  components: { Modal }
}
</script>

<style lang="scss" scoped>
@import "application.scss";

.button {
  width: 100%;

  button {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}

.logo {
  margin-top: 3rem;
  margin-bottom: 2rem;
  width: 100%;
  height: 5rem;

  img { 
    height: 5rem;
  }
}

.modal-content.upgradeModalRectangle {
  height: 40rem;
  padding: 1.438rem 1rem;
  border-radius: 16px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08);
  border: solid 0.5px #b5b5b5;
  background-color: $white;
}

.modal-body {
  height: 100%;
}
</style>

<style lang="scss" scoped>
@import "application.scss";

.Masthead {
  width: 14.25rem;
  height: 2.375rem;
  font-family: SFPro;
  font-size: 2rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.Byline {
  margin: 1rem 1rem 1rem 0;
  font-family: SFPro;
  font-size: 0.9rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;
}

.Byline-Copy {
  width: 8.688rem;
  height: 1.5rem;
  margin: 1rem 1rem 1rem 0;
  font-family: SFPro;
  font-size: 1rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;
}

.Combined-Shape {
  width: 2rem;
  height: 2rem;
  margin: 0 1.125rem 0 0;
  background-image: linear-gradient(340deg, #24d292 92%, #d558c8 9%);
}
</style>
